import { render } from "./OtiForOp.vue?vue&type=template&id=39946382&scoped=true"
import script from "./OtiForOp.vue?vue&type=script&lang=js"
export * from "./OtiForOp.vue?vue&type=script&lang=js"

import "./OtiForOp.vue?vue&type=style&index=0&id=39946382&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39946382"]])

export default __exports__